import Vue from 'vue'
import Router from 'vue-router'
import mobile from './mobile'
import news from './news'

function lazy1(name) {
  return () => import('@/components/' + name)
}
function lazy(name) {
  return () => import('@/views/' + name)
}
Vue.use(Router)

let router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: lazy('index/index.vue'),
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          component: lazy('index/components/index.vue')
        },
        //公司简介
        {
          path: '/companyprofile/introduction',
          name: 'companyprofile-introduction',
          component: lazy('company/introduction.vue')
        },
        {//企业文化
          path: '/companyprofile/culture',
          name: 'companyprofile-culture',
          component: lazy('company/culture.vue')
        },
        //组织机构
        {
          path: '/companyprofile/zzjg',
          name: 'companyprofile-zzjg',
          component: lazy('company/zzjg.vue')
        },
        //新闻
        ...news,
        // 新闻列表
        {
          path: '/news/newslist',
          name: 'news-newslist',
          component: lazy('news/newslist.vue')
        },
        // 资质资信
        {
          path: '/companyprofile/zzzx',
          name: 'companyprofile-zzzx',
          component: lazy('company/zzzx.vue')
        },
        // 公司荣誉
        {
          path: '/companyprofile/gsry',
          name: 'companyprofile-gsry',
          component: lazy('company/gsry.vue')
        },
        // 我们的服务
        {
          path: '/ourservices/project',
          name: 'ourservices-project',
          component: lazy('ourservices/project.vue')
        },
        //我们的服务
        {
          path: '/ouservices/detail',
          name: 'ouservices-detail',
          component: lazy('ourservices/detail.vue')
        },
        // 加入我们
        {
          path: '/joinus/joinusdetail',
          name: 'joinus-joinusdetail',
          component: lazy('joinus/joinusdetail.vue')
        },
        // 分支机构
        {
          path: '/branch/branch',
          name: 'branch-branch',
          component: lazy('branch/branch.vue')
        },
        // 联系我们
        {
          path: '/connectus/connectus',
          name: 'connectus-connectus',
          component: lazy('connectus/connectus.vue')
        },
        // 客户反馈
        {
          path: '/client',
          name: '/client',
          component: lazy('client/client_feedback.vue')
        },
        // 公示公告
        {
          path: '/connectus/publicity',
          name: 'connectus-publicity',
          component: lazy('connectus/publicity.vue')
        },
      ]
    },
    {
      path: "*",
      redirect: '/index'
    },
    ...mobile
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js